﻿/**
 * Interactive Hero
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
    el: ".m10-packages",
    modal: document.getElementById("modal-frame"),
    form: document.getElementById("package-form"),
    thankyou: document.getElementById("package-thankyou"),
    M10PackagesId: 0,
    PackageId: 0,
    Language: 0,
    title: 0,

    events: {
        'click .open-click': "openLb",
        'click .send-email': "emailForm",
        'click #dropdownOpen': "onClickEmailDropdown"
    },

    initialize() {
        //console.log(" initialize m10-packages", this);

        // If a modal can be found, find the content element inside
        if (this.modal) this.content = this.modal.getElementsByClassName("modal__content")[0];
    },



    onRender() {
        //console.log("onRender m10-packages");
    },

    openLb(e) {
        var x = document.getElementById(e.target.dataset.idp);
        var fromimage = document.getElementById(e.delegateTarget.dataset.idp);

        if (x === null) {
            x = fromimage;
        }
        this.content.innerHTML = x.innerHTML;

        //Block body scroll when modal is opened
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        const body = document.body;
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}`;

        //track
        //go to product page link
        var vd = this.content.querySelectorAll('.product-category__link a');

        if (vd.length) {
            for (var i = 0; i < vd.length; ++i) {
                vd[i].addEventListener('click', function (e) {
                    dataLayer.push({
                        "event": "interactionevent",
                        "eventaction": "Click",
                        "eventcategory": "interaction",
                        "eventlabel": "Product page"
                    });
                }, false);
            }
        }
        
        //CTAs
        var ct = this.content.querySelectorAll('.product-details__top-area__links a');
        var receiveEmail = this.content.querySelector('.dropdown-open');
        receiveEmail.addEventListener("click", function (event) {
            event.preventDefault()
        });
        if (ct.length) {
            this.onClickEmailDropdown(ct[0]);
            for (var i = 0; i < ct.length; ++i) {
               
                ct[i].addEventListener('click', function (e) {
                    
                    dataLayer.push({
                        "event": "interactionevent",
                        "eventaction": "Click",
                        "eventcategory": "interaction",
                        "eventlabel": this.innerText
                    });
                }, false);
            }
        }
    },
    emailForm(e) {
        //open modal
        this.content.innerHTML = this.form.innerHTML.replace(/xxxPackage/g, "pkg");
        
        //set vars
        this.M10PackagesId = e.delegateTarget.dataset.m10id;
        this.PackageId = e.delegateTarget.dataset.idp;
        this.Language = e.delegateTarget.dataset.language;
        this.title = e.delegateTarget.dataset.title;
        //attach send email event
        var send = this.content.querySelector(".send-email-button");
        //console.log('send: >', send)
        send.addEventListener("click", this.sendEmail.bind(null, this, send));
        //track
        dataLayer.push({
            "event": "interactionevent",
            "eventaction": "Click",
            "eventcategory": "interaction",
            "eventlabel": "Send via e-mail"
        });
    },
    validation(t, v, type) {
        let vv = false;

        switch (type) {
            case "name":
                vv = /[a-zA-Z\xC0-\uFFFF '-]{2,}/i.test(v);
                t.modal.querySelector(".pkg_fullname .pkg-error-msgs").style.display = !vv ? "block" : "";
                break;
            case "email":
                vv = /^[\w\.-]+@[\w\.-]+\.\w{2,10}$/i.test(v);
                t.modal.querySelector(".pkg_email .pkg-error-msgs").style.display = !vv ? "block" : "";
                break;
            case "privacy":
                vv = v;
                t.modal.querySelector(".pkg_privacy_policy_ .pkg-error-msgs").style.display = !vv ? "block" : "";
                break;
        }

        return vv;
    },
    onClickEmailDropdown(el) {
        var drop = this.content.querySelector('#dropdownContainer');
        var formContainer = this.content.querySelector('.dropdownItem');
        formContainer.innerHTML = this.form.innerHTML.replace(/xxxPackage/g, "pkg");
        var dropCont = this.content.querySelector('#dropdownCont');
        var send = this.content.querySelector(".send-email-button");
        var sendEmail = this.sendEmail;
        var t = this;

        el.addEventListener('click', function (e) {
            e.preventDefault(e);
            t.M10PackagesId = e.target.dataset.m10id;
            t.PackageId = e.target.dataset.idp;
            t.Language = e.target.dataset.language;
            t.title = e.target.dataset.title;

            //attach send email event
            send.addEventListener("click", sendEmail.bind(null, t, send));

            dataLayer.push({
                "event": "interactionevent",
                "eventaction": "Click",
                "eventcategory": "interaction",
                "eventlabel": "Send via e-mail"
            });
            if (this.className === 'open') {
                this.className = '';
                drop.removeAttribute('style');
            } else {
                this.className = 'open';
                drop.style.height = dropCont.offsetHeight + "px";

            }
        })

    },
    sendEmail(t, b) {
        var drop = t.modal.querySelector('#dropdownContainer');
        var dropCont = t.modal.querySelector('#dropdownCont');
        var rName = t.modal.querySelector("#fullname-pkg").value;
        var rEmail = t.modal.querySelector("#email-pkg").value;
        var privacy = t.modal.querySelector("#privacy_policy-pkg").checked ? true : false;
        var consent = t.modal.querySelector("#marketing_material_consent-pkg").checked ? true : false;

        //validation
        let nameV = t.validation(t, rName, "name");
        let emailV = t.validation(t, rEmail, "email");
        let privacyV = t.validation(t, privacy, "privacy");

        if (!nameV || !emailV || !privacyV) {
            drop.style.height = dropCont.offsetHeight + "px";
            return;
        }
        //

        var customerInfo = {
            Name: rName,
            Email: rEmail,
            HasCheckedPrivacy: privacy,
            HasCheckedMarketing: consent, // not mandatory
            PageUrl: window.location.href,
            PageName: window.location.pathname.replace("/", "")
        };

        var lpfRequestPdf = {
            M10PackagesId: t.M10PackagesId,
            PackageId: t.PackageId,
            Language: t.Language
        }

        var requestSendEmail = {
            CustomerInfo: customerInfo,
            RequestPdf: lpfRequestPdf
        }

        //disable button when sending form
        b.classList.add("disabled");

        var xhr = new XMLHttpRequest();
        var url = "/api/sitecore/LandingPage/LpfSendEmail";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                //thank you message
                t.thanks();
                //track
                dataLayer.push({
                    "event": "interactionevent",
                    "eventaction": "Submitted email",
                    "eventcategory": "Hubspot submission",
                    "eventlabel": "Inspiration " + t.title
                });
            }
        };
        var data = JSON.stringify(requestSendEmail);
        xhr.send(data);

    },

    thanks() {
        //load thanks message
        var formContainer = this.content.querySelector('.dropdownItem');
        formContainer.innerHTML = this.thankyou.innerHTML;
        //open modal
        //this.content.innerHTML = this.thankyou.innerHTML;
    }
});

export default View;
